/** Бета в моке не поддерживается: все эндпоинты беты отвечают `not_found`. */
import type { ApiHandlers } from "@newfungame/contracts";
import { ApiError } from "@newfungame/contracts";
import type { FakeDb } from "./db";

const off = async (): Promise<never> => {
  throw new ApiError("not_found", "beta is not available in the mock");
};

export const betaHandlers = (
  _db: FakeDb,
): Pick<
  ApiHandlers,
  | "betaLoadout"
  | "betaWheelSpin"
  | "betaShopBuy"
  | "betaChestOpen"
  | "betaStarUp"
  | "betaGemsInvoice"
  | "betaMapGet"
  | "betaMapAttackStart"
  | "betaMapAttackFinish"
  | "betaMapClaim"
  | "betaMapEnergyBuy"
> => ({
  betaLoadout: off,
  betaWheelSpin: off,
  betaShopBuy: off,
  betaChestOpen: off,
  betaStarUp: off,
  betaGemsInvoice: off,
  betaMapGet: off,
  betaMapAttackStart: off,
  betaMapAttackFinish: off,
  betaMapClaim: off,
  betaMapEnergyBuy: off,
});
